import { useQuery } from "react-query";
import { getMyPerformances } from "../../../faunadb/queries/performance";
import { useFaunav10Context } from "../../../providers/FaunaV10Provider";

export default function useMyPerformancesQuery() {
    const { client } = useFaunav10Context()
    return useQuery(["my_performances"], () => getMyPerformances(client), { refetchOnWindowFocus: false })
}